module.exports = require("!!vue-loader!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./README.md");


//////////////////
// WEBPACK FOOTER
// ./README.md
// module id = G0wi
// module chunks = 1